import { useParams, useNavigate } from "react-router-dom";
import { useRealizacje } from "../Context/RealizacjeContext";
import { useEffect, useRef } from "react";
import "./RealizacjeDetails.css";

const RealizacjeDetails = () => {
  const { id } = useParams();
  const { realizacje, loading } = useRealizacje();
  const navigate = useNavigate();

  // HOOKI ZAWSZE NA POCZĄTKU
  const imagesRef = useRef([]);

  useEffect(() => {
    // tylko mobile
    if (window.innerWidth > 768) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    imagesRef.current.forEach((img) => {
      if (img) observer.observe(img);
    });

    return () => observer.disconnect();
  }, []);

  if (loading) return <p>Ładowanie...</p>;

  const realization = realizacje.find((r) => r.id === id);
  if (!realization) return <div>Realizacja nie znaleziona</div>;

  return (
    <div className="portfolio-wrapper">
      <div className="portfolio-left">
        <h2>{realization.name}</h2>
        <p>{realization.description}</p>
        {realization.points?.length > 0 && (
          <ul>
            {realization.points.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        )}

        <button onClick={() => navigate(-1)} className="back-button">
          ← POWRÓT
        </button>
      </div>

      <div className="portfolio-right">
        {realization.gallery.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`Zdjęcie ${i}`}
            className="gallery-image"
            ref={(el) => (imagesRef.current[i] = el)}
            style={{ transitionDelay: `${i * 0.2}s` }}
          />
        ))}
      </div>
    </div>
  );
};

export default RealizacjeDetails;
